import React from 'react'
import classNames from 'classnames'

import { InternalTaskStatusTagRender } from '@app/components/renderers'
import { LntSelect } from '@app/components/base'

import { SIZE } from '@app/constants'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { INTERNAL_TASKS_KEY } from '@app/constants/queryKeys'

import { getTaskExecutors } from '@app/api/routes/internalTasks'

import { getFilterFromExecutors } from '@app/utils/entitiesAdapters'

import styles from '../styles.module.scss'

import type { DetailsSectionProps } from './types'

export const DetailsSection: React.FC<DetailsSectionProps> = ({ taskId, dataSource, onChangeExecutor }) => {
  const classNameRowTitle: string = classNames(styles.internalTaskSection__rowTitle, styles.grayColor)

  return (
    <div className={ styles.internalTaskSection }>
      <h5 className={ styles.internalTaskSection__title }>Детали задачи</h5>

      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Статус задачи:</span>
        <InternalTaskStatusTagRender status={ dataSource?.status } />
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Дата создания:</span>
        <span>{ dataSource?.createdAt }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Инициатор:</span>
        <span>{ dataSource?.initiator }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Роль:</span>
        <span>{ dataSource?.role }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Срок исполнения:</span>
        <span>{ dataSource?.deadline }</span>
      </div>
      <div className={ styles.internalTaskSection__row }>
        <span className={ classNameRowTitle }>Исполнитель:</span>
        <LntSelect
          strictValue
          showArrow
          size={ SIZE.small }
          value={ dataSource?.executor?.id }
          onChange={ onChangeExecutor }
          placeholder={ FILTERS_PLACEHOLDERS.executorFilter }
          querySelect={ {
            queryKey: [INTERNAL_TASKS_KEY.internalTasksExecutorItems],
            queryFn: async () => await getTaskExecutors({ taskId: taskId ?? '' }),
            select: getFilterFromExecutors
          } }
        />
      </div>
    </div>
  )
}
